import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

// Utils
import UniversalLink from "§/src/utils/UniversalLink"
import { lazyIframeModal } from "§/src/utils/lazyIframeModal";

// Internal
import "./_tile-content-product.scss"

// Atoms
import ProductBadge from "§/src/components/atoms/badge/product-badge"
import ButtonArrow from "§/src/components/atoms/buttons/button-arrow"
const Modal = React.lazy(() => import("§/src/components/atoms/content/modal"))

// Functions
import { configuratorLink } from "§/src/utils/configuratorLink";

// Language
import { useTranslation } from "react-i18next"

const TileContentProduct = props => {
  const { t } = useTranslation()
  const modalid = "modal-" + Math.floor(Math.random() * 9999)
  const defAlt = props.defAlt

  const {
    uri,
    title,
    featuredImage,
    acf,
    productCategories,
    menuOrder,
    pfsAccuracy,
    pfsApplication,
    pfsCertificationNorms,
    pfsCharacteristic,
    pfsCurrentRate,
    pfsExCertification,
    pfsFeatures,
    pfsFieldbus,
    pfsFormatMounting,
    pfsHeatsink,
    pfsLoopController,
    pfsMeasuredVariable,
    pfsMechanicalCharacteristic,
    pfsMounting,
    pfsPhase,
    pfsSafetyConformityCert,
    pfsSignalOutput,
    pfsStroke,
    pfsType,
    pfsTypeControl,
    pfsVariable,
    pfsSeries,
    pfsInputOutput,
    pfsSystemAndAccessories,
    pfsFunctionalModules,
    ...atomProps
  } = props.data
  // const formattedDate = getFormattedDate(date)

  // set atom class
  const atomClassName = "tile-content-product"
  var atomClass =
    props.className != undefined
      ? atomClassName + " " + props.className
      : atomClassName

  // If is set configModalId (from related-products component)
  // then pass id and configLink to open a unique modal (set f.ex. in related-products component)
  function iframeLoader(el, configLink){
    if(props?.configModalId){
      lazyIframeModal('#' + props.configModalId, configLink)
    } else {
      lazyIframeModal(el)
    }
  }

  // Configurator Link
  const siteLanguage = process.env.GATSBY_SITE_LANG
  const originalId = acf.originalId
  const configLink = configuratorLink(acf?.configuratorLink, siteLanguage, originalId)

  const titleTag = props?.titleTag

  const TitleComponent = ({ title, titleTag: TitleTag = 'h4' }) => {
    return <TitleTag className="title h4">{title}</TitleTag>;
  };

  return (
    <React.Fragment>
      {
        !props?.configModalId &&
          <Modal modalid={modalid} className="iframeModal">
            <div className="ratio mt-4 mb-4">
              <iframe
                data-src={configLink}
                className="embed-responsive-item"
              ></iframe>
            </div>
          </Modal>
      }

      <div className={atomClass} {...atomProps}>
        <div className="tile-container">
          <div className="top">
            {acf?.badge && <ProductBadge data={acf.badge} size="sm" />}

            <div className="configurator-link">
              {configLink && (
                <ButtonArrow
                  dir="end"
                  text={t("Configura")}
                  data-bs-toggle="modal"
                  data-bs-target={ props?.configModalId ? `#${props?.configModalId}` : `#${modalid}`}
                  onMouseEnter={el => { iframeLoader(`#${modalid}`, configLink) }}
                  onClick={el => { iframeLoader(`#${modalid}`, configLink) }}
                  className="text-black bg-gray ms-auto"
                ></ButtonArrow>
              )}
            </div>
          </div>

          <div className="product-link">
            {featuredImage && (
              <GatsbyImage
                className="sw-image"
                image={getImage(featuredImage?.node?.gatsbyImage)}
                objectFit="contain"
                alt={defAlt || featuredImage?.altText || ""}
              />
            )}

            <div className="text-cont">
              <TitleComponent title={title} titleTag={titleTag} />
              <div className="desc">{acf?.subTitle}</div>
            </div>

            <button className="cta btn btn-primary">
              {t("Scopri di più")}
            </button>

            <UniversalLink
              className="link-button stretched-link"
              to={uri}
            ></UniversalLink>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default TileContentProduct
